export default "__VITE_ASSET__DSJeF1QT__"